export class RequestPayload {
  orderType: string; 
  firstName: string; 
  lastName: string; 
  houseNumber: string; 
  street: string;  
  city: string;
  newCity: string;
  state: string;  
  gender: string; 
  zip: string;  
  safePhone: string; 
  extension: string;
  ssn: string;
  contractAccountNo: string;
  customerRequestInformation: string;
  reqReconnectDt: Date | null;
  reconnectApptTm: string;
  newHouseNumber: string;
  newStreet: string;
  newCityValue: string;
  newStateSelectedValue: string;
  newZip: string;
  meterNumber: string;
  installationNumber: string;
  driverLicenseState: string;
  driverLicenseNumber: string;
  maritalStatus: string;
  setupInSpouseName: string;
  spouseSSN: string;
     
  constructor(
    orderType: string,
    firstName: string,
    lastName: string,
    houseNumber: string,
    street: string,
    city: string,
    newCity: string,
    state: string,
    gender: string,
    zip: string,
    safePhone: string,
    extension: string,
    ssn: string,
    contractAccountNo: string,
    customerRequestInformation: string,
    reqReconnectDt: Date,
    reconnectApptTm: string,
    newHouseNumber: string,
    newStreet: string,
    newCityValue: string,
    newStateSelectedValue: string,
    newZip: string,
    meterNumber: string,
    installationNumber: string,
    driverLicenseState: string,
    driverLicenseNumber: string,
    maritalStatus: string,
    setupInSpouseName: string,
    spouseSSN: string
  ) 
  {
    this.orderType = orderType;
    this.firstName = firstName;
    this.lastName = lastName;
    this.houseNumber = houseNumber;
    this.street = street;
    this.city = city;
    this.newCity = newCity;
    this.state = state;
    this.gender = gender;
    this.zip = zip;
    this.safePhone = safePhone;
    this.extension = extension;
    this.ssn = ssn;
    this.contractAccountNo = contractAccountNo;
    this.customerRequestInformation = customerRequestInformation; 
    this.reqReconnectDt = reqReconnectDt;
    this.reconnectApptTm = reconnectApptTm;
    this.newHouseNumber = newHouseNumber;
    this.newStreet = newStreet;
    this.newCityValue = newCityValue;
  this.newStateSelectedValue = newStateSelectedValue;
  this.newCityValue = newCityValue;
  this.newStateSelectedValue = newStateSelectedValue;
  this.newZip = newZip;
    this.meterNumber = meterNumber;
  this.installationNumber = installationNumber;
  this.driverLicenseState = driverLicenseState;
  this.driverLicenseNumber = driverLicenseNumber;
  this.maritalStatus = maritalStatus;
  this.setupInSpouseName = setupInSpouseName;
  this.spouseSSN = spouseSSN;
  } 
}